"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var effects_1 = require("redux-saga/effects");
var billingAgreementState_1 = require("../states/billingAgreementState");
var billingAgreementService_1 = require("../services/billingAgreementService");
var authSelectors_1 = require("../selectors/authSelectors");
var settingsSelectors_1 = require("../selectors/settingsSelectors");
var consumerSelector_1 = require("../selectors/consumerSelector");
var productContractSelectors_1 = require("../selectors/productContractSelectors");
var billingAgreementSelectors_1 = require("../selectors/billingAgreementSelectors");
var paymentState_1 = require("../states/paymentState");
var i18n_1 = __importDefault(require("../i18n"));
var reportErrorsToInstrumentation_1 = __importStar(require("../helper/reportErrorsToInstrumentation"));
var billingAgreement_1 = __importDefault(require("../models/billingAgreement"));
var payment_1 = __importDefault(require("../models/payment"));
var authState_1 = require("../states/authState");
var utils_1 = require("../helper/utils");
var SwitchToDirectDebitRequestHelper_1 = require("../helper/SwitchToDirectDebitRequestHelper");
function fetchBillingAgreementsAndScheduledInstalmentsEffect(action) {
    var token, _a, scheduledInstalments, remainingProperties_1, billing, payments, e_1, language, errorMsg;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 6, , 13]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _b.sent();
                if (!token)
                    throw Error("Missing token");
                return [4 /*yield*/, (0, effects_1.call)(billingAgreementService_1.fetchBillingAgreementsAndScheduledInstalmentsService, action.payload, token)];
            case 2:
                _a = _b.sent(), scheduledInstalments = _a.scheduledInstalments, remainingProperties_1 = __rest(_a, ["scheduledInstalments"]);
                billing = new billingAgreement_1.default(remainingProperties_1);
                payments = scheduledInstalments.map(function (si) {
                    return new payment_1.default(__assign(__assign({}, si), { accountId: remainingProperties_1.customerAccountId }));
                });
                return [4 /*yield*/, (0, effects_1.put)(paymentState_1.paymentsActions.fetchPaymentsHistorySuccess(payments))];
            case 3:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.delay)(100)];
            case 4:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.fetchBillingAgreementsAndScheduledInstalmentsSuccess(billing))];
            case 5:
                _b.sent();
                return [3 /*break*/, 13];
            case 6:
                e_1 = _b.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 7:
                language = (_b.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_1)) return [3 /*break*/, 9];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 8:
                _b.sent();
                return [3 /*break*/, 11];
            case 9: return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.fetchBillingAgreementsAndScheduledInstalmentsError(errorMsg))];
            case 10:
                _b.sent();
                _b.label = 11;
            case 11: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_1, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, fetchBillingAgreementsAndScheduledInstalmentsEffect.name))];
            case 12:
                _b.sent();
                return [3 /*break*/, 13];
            case 13: return [2 /*return*/];
        }
    });
}
function fetchBillingAddressEffect(action) {
    var token, data, e_2, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 11]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error("Missing token");
                return [4 /*yield*/, (0, effects_1.call)(billingAgreementService_1.getBillingAddressByCustomerAccountIdService, action.payload, token)];
            case 2:
                data = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.getBillingAddressSuccess(data))];
            case 3:
                _a.sent();
                return [3 /*break*/, 11];
            case 4:
                e_2 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_2)) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 6:
                _a.sent();
                return [3 /*break*/, 9];
            case 7: return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.getBillingAddressFailure(errorMsg))];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_2, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, fetchBillingAddressEffect.name))];
            case 10:
                _a.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
function fetchBillingAgreementEffect(action) {
    var token, data, e_3, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 11]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error("Missing token");
                return [4 /*yield*/, (0, effects_1.call)(billingAgreementService_1.fetchBillingAgreementService, action.payload, token)];
            case 2:
                data = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.getBillingAgreementSuccess(data))];
            case 3:
                _a.sent();
                return [3 /*break*/, 11];
            case 4:
                e_3 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_3)) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 6:
                _a.sent();
                return [3 /*break*/, 9];
            case 7: return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.getBillingAgreementFailure(errorMsg))];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_3, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, fetchBillingAgreementEffect.name))];
            case 10:
                _a.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
/**
 *
 * @param action
 */
function activateDirectDebitEffect(action) {
    var token, billingAgreementState, info, response, e_4, language, errorMsg;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 5, , 12]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _d.sent();
                return [4 /*yield*/, (0, effects_1.select)(billingAgreementSelectors_1.getBillingAgreementState)];
            case 2:
                billingAgreementState = _d.sent();
                if (!token)
                    throw Error("Missing token");
                if (!billingAgreementState || !((_a = billingAgreementState === null || billingAgreementState === void 0 ? void 0 : billingAgreementState.iban) === null || _a === void 0 ? void 0 : _a.numberOfPeople) || !((_b = billingAgreementState === null || billingAgreementState === void 0 ? void 0 : billingAgreementState.iban) === null || _b === void 0 ? void 0 : _b.withdrawalDate) || !((_c = billingAgreementState === null || billingAgreementState === void 0 ? void 0 : billingAgreementState.iban) === null || _c === void 0 ? void 0 : _c.value))
                    throw Error("Missing BillingAgreement or iban elements are null");
                info = {
                    iban: billingAgreementState.iban.value,
                    numberbOfPeople: billingAgreementState.iban.numberOfPeople,
                    debitDate: billingAgreementState.iban.withdrawalDate,
                    dematerialization: action.payload.Ebill,
                    sectionSubscriptionId: action.payload.sectionSubscriptionId,
                    clientId: action.payload.ClientId,
                    customerAccountId: action.payload.customerAccountId
                };
                return [4 /*yield*/, (0, effects_1.call)(billingAgreementService_1.activateDirectDebitService, token, info)];
            case 3:
                response = _d.sent();
                return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.activateDirectDebitSuccess(action.payload.Ebill, false, false, false, response))];
            case 4:
                _d.sent();
                return [3 /*break*/, 12];
            case 5:
                e_4 = _d.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 6:
                language = (_d.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_4)) return [3 /*break*/, 8];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 7:
                _d.sent();
                return [3 /*break*/, 10];
            case 8: return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.activateDirectDebitFailure(errorMsg))];
            case 9:
                _d.sent();
                _d.label = 10;
            case 10: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_4, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, activateDirectDebitEffect.name))];
            case 11:
                _d.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
function activateDirectDebitWithEstimateEffect(action) {
    var token, billingAgreementState, info, response, e_5, language, errorMsg;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 5, , 12]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _c.sent();
                return [4 /*yield*/, (0, effects_1.select)(billingAgreementSelectors_1.getBillingAgreementState)];
            case 2:
                billingAgreementState = _c.sent();
                if (!token)
                    throw Error('Missing token');
                if (!billingAgreementState ||
                    !((_a = billingAgreementState === null || billingAgreementState === void 0 ? void 0 : billingAgreementState.iban) === null || _a === void 0 ? void 0 : _a.withdrawalDate) ||
                    !((_b = billingAgreementState === null || billingAgreementState === void 0 ? void 0 : billingAgreementState.iban) === null || _b === void 0 ? void 0 : _b.value))
                    throw Error('Missing BillingAgreement or iban elements are null');
                info = {
                    iban: billingAgreementState.iban.value,
                    debitDate: billingAgreementState.iban.withdrawalDate,
                    dematerialization: action.payload.Ebill,
                    sectionSubscriptionId: action.payload.sectionSubscriptionId,
                    clientId: action.payload.ClientId,
                    customerAccountId: action.payload.customerAccountId,
                    monthlyEstimation: action.payload.monthlyEstimation
                };
                return [4 /*yield*/, (0, effects_1.call)(billingAgreementService_1.activateDirectDebitServiceWithEstimate, token, info)];
            case 3:
                response = _c.sent();
                return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.activateDirectDebitSuccess(action.payload.Ebill, false, action.payload.monthlyEstimation !== 0, true, response))];
            case 4:
                _c.sent();
                return [3 /*break*/, 12];
            case 5:
                e_5 = _c.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 6:
                language = (_c.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_5)) return [3 /*break*/, 8];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 7:
                _c.sent();
                return [3 /*break*/, 10];
            case 8: return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.activateDirectDebitFailure(errorMsg))];
            case 9:
                _c.sent();
                _c.label = 10;
            case 10: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_5, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, activateDirectDebitWithEstimateEffect.name))];
            case 11:
                _c.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
function switchFromDirectDebitAtMaturityToMonthlyEffect(action) {
    var token, billingAgreementState, billingAgreementData, isDirectDebitAtMaturity, info, response, e_6, language, errorMsg;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 7, , 14]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _d.sent();
                return [4 /*yield*/, (0, effects_1.select)(billingAgreementSelectors_1.getBillingAgreementState)];
            case 2:
                billingAgreementState = _d.sent();
                if (!token)
                    throw Error("Missing token");
                if (!billingAgreementState || !((_a = billingAgreementState === null || billingAgreementState === void 0 ? void 0 : billingAgreementState.iban) === null || _a === void 0 ? void 0 : _a.numberOfPeople) || !((_b = billingAgreementState === null || billingAgreementState === void 0 ? void 0 : billingAgreementState.iban) === null || _b === void 0 ? void 0 : _b.withdrawalDate) || !((_c = billingAgreementState === null || billingAgreementState === void 0 ? void 0 : billingAgreementState.iban) === null || _c === void 0 ? void 0 : _c.value))
                    throw Error("Missing BillingAgreement or iban elements are null");
                billingAgreementData = billingAgreementState.billingAgreements.data;
                isDirectDebitAtMaturity = (billingAgreementData === null || billingAgreementData === void 0 ? void 0 : billingAgreementData.directDebit) && (billingAgreementData === null || billingAgreementData === void 0 ? void 0 : billingAgreementData.paymentMethodCode) === "maturity";
                info = (0, SwitchToDirectDebitRequestHelper_1.buildSwitchFromMaturityToDirectDebitBody)(billingAgreementState, action.payload);
                if (info === null)
                    throw Error("Error while building request body");
                if (!isDirectDebitAtMaturity) return [3 /*break*/, 5];
                return [4 /*yield*/, (0, effects_1.call)(billingAgreementService_1.switchFromDirectDebitAtMaturityToMonthly, token, info)];
            case 3:
                response = _d.sent();
                return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.activateDirectDebitSuccess(action.payload.Ebill, isDirectDebitAtMaturity, false, false, response))];
            case 4:
                _d.sent();
                return [3 /*break*/, 6];
            case 5: throw Error("This user paymentCode is not at maturity");
            case 6: return [3 /*break*/, 14];
            case 7:
                e_6 = _d.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 8:
                language = (_d.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_6)) return [3 /*break*/, 10];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 9:
                _d.sent();
                return [3 /*break*/, 12];
            case 10: return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.activateDirectDebitFailure(errorMsg))];
            case 11:
                _d.sent();
                _d.label = 12;
            case 12: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_6, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, switchFromDirectDebitAtMaturityToMonthlyEffect.name))];
            case 13:
                _d.sent();
                return [3 /*break*/, 14];
            case 14: return [2 /*return*/];
        }
    });
}
function switchFromDirectDebitAtMaturityToMonthlyWithEstimateEffect(action) {
    var token, billingAgreementState, billingAgreementData, isDirectDebitAtMaturity, info, response, e_7, language, errorMsg;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 7, , 14]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _b.sent();
                return [4 /*yield*/, (0, effects_1.select)(billingAgreementSelectors_1.getBillingAgreementState)];
            case 2:
                billingAgreementState = _b.sent();
                if (!token)
                    throw Error('Missing token');
                if (!billingAgreementState ||
                    !((_a = billingAgreementState === null || billingAgreementState === void 0 ? void 0 : billingAgreementState.iban) === null || _a === void 0 ? void 0 : _a.withdrawalDate))
                    throw Error('Missing BillingAgreement or iban elements are null');
                billingAgreementData = billingAgreementState.billingAgreements.data;
                isDirectDebitAtMaturity = (billingAgreementData === null || billingAgreementData === void 0 ? void 0 : billingAgreementData.directDebit) &&
                    (billingAgreementData === null || billingAgreementData === void 0 ? void 0 : billingAgreementData.paymentMethodCode) === 'maturity';
                info = (0, SwitchToDirectDebitRequestHelper_1.buildSwitchFromMaturityToDirectDebitWithEstimateBody)(billingAgreementState, action.payload);
                if (info === null)
                    throw Error('Error while building request body');
                if (!isDirectDebitAtMaturity) return [3 /*break*/, 5];
                return [4 /*yield*/, (0, effects_1.call)(billingAgreementService_1.activateDirectDebitServiceWithEstimate, token, info)];
            case 3:
                response = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.activateDirectDebitSuccess(action.payload.Ebill, isDirectDebitAtMaturity, action.payload.monthlyEstimation !== 0, true, response))];
            case 4:
                _b.sent();
                return [3 /*break*/, 6];
            case 5: throw Error('This user paymentCode is not at maturity');
            case 6: return [3 /*break*/, 14];
            case 7:
                e_7 = _b.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 8:
                language = (_b.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_7)) return [3 /*break*/, 10];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 9:
                _b.sent();
                return [3 /*break*/, 12];
            case 10: return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.activateDirectDebitFailure(errorMsg))];
            case 11:
                _b.sent();
                _b.label = 12;
            case 12: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_7, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, switchFromDirectDebitAtMaturityToMonthlyWithEstimateEffect.name))];
            case 13:
                _b.sent();
                return [3 /*break*/, 14];
            case 14: return [2 /*return*/];
        }
    });
}
function activateDirectDebitAtMaturityEffect(action) {
    var token, billingAgreementState, info, e_8, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 12]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(billingAgreementSelectors_1.getBillingAgreementState)];
            case 2:
                billingAgreementState = _a.sent();
                if (!token)
                    throw Error("Missing token");
                if (!billingAgreementState)
                    throw Error("Missing BillingAgreement");
                if (!billingAgreementState.iban.value)
                    throw Error("Missing iban value");
                info = {
                    iban: billingAgreementState.iban.value,
                    dematerialization: action.payload.Ebill,
                    clientId: action.payload.ClientId,
                    customerAccountId: action.payload.customerAccountId,
                };
                return [4 /*yield*/, (0, effects_1.call)(billingAgreementService_1.activateDirectDebitServiceAtMaturity, token, info)];
            case 3:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.activateDirectDebitAtMaturitySuccess(action.payload.Ebill))];
            case 4:
                _a.sent();
                return [3 /*break*/, 12];
            case 5:
                e_8 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 6:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_8)) return [3 /*break*/, 8];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 7:
                _a.sent();
                return [3 /*break*/, 10];
            case 8: return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.activateDirectDebitAtMaturityFailure(errorMsg))];
            case 9:
                _a.sent();
                _a.label = 10;
            case 10: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_8, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, activateDirectDebitAtMaturityEffect.name))];
            case 11:
                _a.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
//TODO to delete this function is not used and the same things apply to the state
function activateElectronicInvoiceEffect(action) {
    var token, consumer, productContractId, e_9, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 13]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(consumerSelector_1.getConsumer)];
            case 2:
                consumer = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(productContractSelectors_1.getProductContractId)];
            case 3:
                productContractId = _a.sent();
                if (!token)
                    throw Error("Missing token");
                if (!productContractId)
                    throw Error("Missing product Contract Id");
                return [4 /*yield*/, (0, effects_1.call)(billingAgreementService_1.activateElectronicInvoiceService, token, consumer.clientId, productContractId)];
            case 4:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.activateElectronicInvoiceSuccess())];
            case 5:
                _a.sent();
                return [3 /*break*/, 13];
            case 6:
                e_9 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 7:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_9)) return [3 /*break*/, 9];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 8:
                _a.sent();
                return [3 /*break*/, 11];
            case 9: return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.activateElectronicInvoiceFailure(errorMsg))];
            case 10:
                _a.sent();
                _a.label = 11;
            case 11: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_9, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, activateElectronicInvoiceEffect.name))];
            case 12:
                _a.sent();
                return [3 /*break*/, 13];
            case 13: return [2 /*return*/];
        }
    });
}
function terminateElectronicInvoiceEffect(action) {
    var token, error_1, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 8]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error("Missing token");
                return [4 /*yield*/, (0, effects_1.call)(billingAgreementService_1.terminateElectronicInvoiceService, token, action.payload.customerAccountId)];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.terminateElectronicInvoiceSuccess())];
            case 3:
                _a.sent();
                return [3 /*break*/, 8];
            case 4:
                error_1 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.terminateElectronicInvoiceFailure(errorMsg))];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, error_1, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, terminateElectronicInvoiceEffect.name))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function activateEBillEffect(action) {
    var token, e_10, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 11]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error("Missing token");
                return [4 /*yield*/, (0, effects_1.call)(billingAgreementService_1.activateElectronicInvoiceService, token, action.payload.ClientId, action.payload.customerAccountId)];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.activateElectronicInvoiceSuccess())];
            case 3:
                _a.sent();
                return [3 /*break*/, 11];
            case 4:
                e_10 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_10)) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 6:
                _a.sent();
                return [3 /*break*/, 9];
            case 7: return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.activateElectronicInvoiceFailure(errorMsg))];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_10, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, activateEBillEffect.name))];
            case 10:
                _a.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
function BillingAdressEffect(action) {
    var token, e_11, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 11]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error("Missing token");
                return [4 /*yield*/, (0, effects_1.call)(billingAgreementService_1.UpdateAdressBilingService, action.payload, token)];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.updateBillingAddressSuccess())];
            case 3:
                _a.sent();
                return [3 /*break*/, 11];
            case 4:
                e_11 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_11)) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 6:
                _a.sent();
                return [3 /*break*/, 9];
            case 7: return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.updateBillingAddressFailure(errorMsg))];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_11, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, BillingAdressEffect.name))];
            case 10:
                _a.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
function IbanEffect(action) {
    var token, e_12, language, errorMsg;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 5, , 16]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _c.sent();
                if (!token)
                    throw Error("Missing token");
                return [4 /*yield*/, (0, effects_1.call)(billingAgreementService_1.updateIbanService, action.payload, token)];
            case 2:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.updateIbanSuccess())];
            case 3:
                _c.sent();
                //FIXME: temporary solution for business while waiting for HOT DATA
                return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.setIban(action.payload.iban))];
            case 4:
                //FIXME: temporary solution for business while waiting for HOT DATA
                _c.sent();
                return [3 /*break*/, 16];
            case 5:
                e_12 = _c.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 6:
                language = (_c.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_12)) return [3 /*break*/, 8];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 7:
                _c.sent();
                return [3 /*break*/, 14];
            case 8:
                if (!(((_a = e_12 === null || e_12 === void 0 ? void 0 : e_12.response) === null || _a === void 0 ? void 0 : _a.status) === 406)) return [3 /*break*/, 10];
                return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.updateIbanFailureInvalidIban((0, i18n_1.default)(language).updateIban.invalidIban))];
            case 9:
                _c.sent();
                return [3 /*break*/, 14];
            case 10:
                if (!(((_b = e_12 === null || e_12 === void 0 ? void 0 : e_12.response) === null || _b === void 0 ? void 0 : _b.status) === 409)) return [3 /*break*/, 12];
                return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.updateIbanFailureInvalidIban((0, i18n_1.default)(language).updateIban.updateIsPending))];
            case 11:
                _c.sent();
                return [3 /*break*/, 14];
            case 12: return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.updateIbanFailure(errorMsg))];
            case 13:
                _c.sent();
                _c.label = 14;
            case 14: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_12, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, IbanEffect.name))];
            case 15:
                _c.sent();
                return [3 /*break*/, 16];
            case 16: return [2 /*return*/];
        }
    });
}
function checkIbanValidityEffect(action) {
    var token, e_13, language, errorMsg;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 4, , 13]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _b.sent();
                if (!token)
                    throw Error("Missing token");
                return [4 /*yield*/, (0, effects_1.call)(billingAgreementService_1.checkIbanValidityService, action.payload, token)];
            case 2:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.ibanIsValid())];
            case 3:
                _b.sent();
                return [3 /*break*/, 13];
            case 4:
                e_13 = _b.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_b.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_13)) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 6:
                _b.sent();
                return [3 /*break*/, 11];
            case 7:
                if (!(((_a = e_13 === null || e_13 === void 0 ? void 0 : e_13.response) === null || _a === void 0 ? void 0 : _a.status) === 406)) return [3 /*break*/, 9];
                return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.ibanIsNotValid((0, i18n_1.default)(language).updateIban.invalidIban))];
            case 8:
                _b.sent();
                return [3 /*break*/, 11];
            case 9: return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.checkIbanValidityFailure(errorMsg))];
            case 10:
                _b.sent();
                _b.label = 11;
            case 11: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_13, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, checkIbanValidityEffect.name))];
            case 12:
                _b.sent();
                return [3 /*break*/, 13];
            case 13: return [2 /*return*/];
        }
    });
}
function checkIbanOffValidityEffect(action) {
    var e_14, language, errorMsg;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 12]);
                return [4 /*yield*/, (0, effects_1.call)(billingAgreementService_1.checkIbanOffValidityService, action.payload)];
            case 1:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.ibanIsValid())];
            case 2:
                _b.sent();
                return [3 /*break*/, 12];
            case 3:
                e_14 = _b.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 4:
                language = (_b.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_14)) return [3 /*break*/, 6];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 5:
                _b.sent();
                return [3 /*break*/, 10];
            case 6:
                if (!(((_a = e_14 === null || e_14 === void 0 ? void 0 : e_14.response) === null || _a === void 0 ? void 0 : _a.status) === 406)) return [3 /*break*/, 8];
                return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.ibanIsNotValid((0, i18n_1.default)(language).updateIban.invalidIban))];
            case 7:
                _b.sent();
                return [3 /*break*/, 10];
            case 8: return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.checkIbanValidityFailure(errorMsg))];
            case 9:
                _b.sent();
                _b.label = 10;
            case 10: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_14, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, checkIbanOffValidityEffect.name))];
            case 11:
                _b.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
function fetchMonthlyEstimateAmountEffect(action) {
    var token, response, e_15, language, errorMsg, errorCode;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 7, , 14]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _b.sent();
                if (!token)
                    throw Error("Missing token");
                return [4 /*yield*/, (0, effects_1.call)(billingAgreementService_1.getMonthlyEstimateAmountService, action.payload, token)];
            case 2:
                response = _b.sent();
                if (!((response === null || response === void 0 ? void 0 : response.status) === 200)) return [3 /*break*/, 4];
                return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.getMonthlyEstimateAmountSuccess({ responseCode: response === null || response === void 0 ? void 0 : response.status, data: response.data }))];
            case 3:
                _b.sent();
                return [3 /*break*/, 6];
            case 4:
                if (!((response === null || response === void 0 ? void 0 : response.status) === 204)) return [3 /*break*/, 6];
                return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.getMonthlyEstimateAmountSuccess({ responseCode: response === null || response === void 0 ? void 0 : response.status, data: null }))];
            case 5:
                _b.sent();
                _b.label = 6;
            case 6: return [3 /*break*/, 14];
            case 7:
                e_15 = _b.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 8:
                language = (_b.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (e_15 && e_15.response && e_15.response.status && e_15.response.status === 404) {
                    errorMsg = (0, i18n_1.default)(language).common.errorGetData;
                }
                if (!(0, utils_1.unauthorizedError)(e_15)) return [3 /*break*/, 10];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 9:
                _b.sent();
                return [3 /*break*/, 12];
            case 10:
                errorCode = (_a = e_15 === null || e_15 === void 0 ? void 0 : e_15.response) === null || _a === void 0 ? void 0 : _a.status;
                return [4 /*yield*/, (0, effects_1.put)(billingAgreementState_1.billingAgreementActions.getMonthlyEstimateAmountFailure(errorMsg, errorCode))];
            case 11:
                _b.sent();
                _b.label = 12;
            case 12: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_15, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, fetchMonthlyEstimateAmountEffect.name))];
            case 13:
                _b.sent();
                return [3 /*break*/, 14];
            case 14: return [2 /*return*/];
        }
    });
}
function billingAgreementEffects() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(billingAgreementState_1.billingAgreementActions.getBillingAddress.type, fetchBillingAddressEffect)];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(billingAgreementState_1.billingAgreementActions.getBillingAgreement.type, fetchBillingAgreementEffect)];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(billingAgreementState_1.billingAgreementActions.activateDirectDebit.type, activateDirectDebitEffect)];
            case 3:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(billingAgreementState_1.billingAgreementActions.switchFromDirectDebitAtMaturityToMonthly.type, switchFromDirectDebitAtMaturityToMonthlyEffect)];
            case 4:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(billingAgreementState_1.billingAgreementActions.activateDirectDebitWithEstimate.type, activateDirectDebitWithEstimateEffect)];
            case 5:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(billingAgreementState_1.billingAgreementActions.switchFromDirectDebitAtMaturityToMonthlyWithEstimate.type, switchFromDirectDebitAtMaturityToMonthlyWithEstimateEffect)];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(billingAgreementState_1.billingAgreementActions.activateDirectDebitAtMaturity.type, activateDirectDebitAtMaturityEffect)];
            case 7:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(billingAgreementState_1.billingAgreementActions.activateElectronicInvoice.type, activateElectronicInvoiceEffect)];
            case 8:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(billingAgreementState_1.billingAgreementActions.activateEBill.type, activateEBillEffect)];
            case 9:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(billingAgreementState_1.billingAgreementActions.updateBillingAddress.type, BillingAdressEffect)];
            case 10:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(billingAgreementState_1.billingAgreementActions.updateIban.type, IbanEffect)];
            case 11:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(billingAgreementState_1.billingAgreementActions.checkIbanValidity.type, checkIbanValidityEffect)];
            case 12:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(billingAgreementState_1.billingAgreementActions.checkIbanOffValidity.type, checkIbanOffValidityEffect)];
            case 13:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(billingAgreementState_1.billingAgreementActions.fetchBillingAgreementsAndScheduledInstalments.type, fetchBillingAgreementsAndScheduledInstalmentsEffect)];
            case 14:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(billingAgreementState_1.billingAgreementActions.terminateElectronicInvoice.type, terminateElectronicInvoiceEffect)];
            case 15:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(billingAgreementState_1.billingAgreementActions.getMonthlyEstimateAmount.type, fetchMonthlyEstimateAmountEffect)];
            case 16:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.default = billingAgreementEffects;
